// Animated growing tree driven by a 0-100 score. Grows only, never recedes.
export default function GrowingTree({ score = 0, stage = "Graine", compact = false, label = null }) {
  const s = Math.max(0, Math.min(100, score));
  const trunkHeight = 40 + (s / 100) * 150; // 40 -> 190
  const trunkTop = 250 - trunkHeight;
  const showSprout = s >= 8;
  const canopy = s >= 30;
  const canopyR = 30 + (s / 100) * 70;
  const flowers = s >= 80;

  const leaves = [];
  const leafCount = Math.floor((s / 100) * 9);
  for (let i = 0; i < leafCount; i++) {
    const side = i % 2 === 0 ? -1 : 1;
    const ly = trunkTop + 20 + i * 16;
    leaves.push(
      <g key={i} className="leaf-grow" style={{ animationDelay: `${i * 0.12}s` }}>
        <ellipse cx={150 + side * (14 + (i % 3) * 6)} cy={ly} rx="13" ry="7"
          fill="#10B981" transform={`rotate(${side * 30} ${150 + side * (14 + (i % 3) * 6)} ${ly})`} />
      </g>
    );
  }

  return (
    <div data-testid={compact ? "garden-tree" : "animated-tree-canvas"} className="w-full flex flex-col items-center">
      <svg viewBox="0 0 300 280" className={compact ? "w-full max-w-[110px]" : "w-full max-w-[260px]"}>
        <ellipse cx="150" cy="258" rx="90" ry="14" fill="#141C17" />
        <ellipse cx="150" cy="256" rx="70" ry="9" fill="#1d2a22" />
        {!showSprout && <circle cx="150" cy="248" r="9" fill="#C8FF00" />}
        <g className="tree-sway">
          {showSprout && (
            <rect x="144" y={trunkTop} width="12" height={trunkHeight} rx="6"
              fill="#6b4a2b" style={{ transition: "all 0.8s ease" }} />
          )}
          {canopy && (
            <g style={{ transition: "all 0.8s ease" }}>
              <circle cx="150" cy={trunkTop} r={canopyR} fill="#0f7a52" opacity="0.9" />
              <circle cx={150 - canopyR * 0.5} cy={trunkTop + 12} r={canopyR * 0.6} fill="#10B981" opacity="0.9" />
              <circle cx={150 + canopyR * 0.5} cy={trunkTop + 12} r={canopyR * 0.6} fill="#0f8a5c" opacity="0.9" />
              <circle cx="150" cy={trunkTop - canopyR * 0.4} r={canopyR * 0.55} fill="#13a06b" opacity="0.9" />
            </g>
          )}
          {leaves}
          {flowers && [-1, 0, 1].map((k) => (
            <circle key={k} cx={150 + k * canopyR * 0.5} cy={trunkTop + (k === 0 ? -8 : 6)} r="6" fill="#C8FF00" />
          ))}
        </g>
      </svg>
      {compact ? (
        label && <span className="mt-1 text-[11px] font-semibold text-white/70 text-center">{label}</span>
      ) : (
        <div className="mt-3 flex items-center gap-2">
          <span data-testid="tree-stage-badge"
            className="rounded-full bg-lime-400/15 text-lime-300 text-xs font-semibold px-3 py-1 border border-lime-400/30">
            {stage}
          </span>
          <span className="text-xs text-white/40">{s}%</span>
        </div>
      )}
    </div>
  );
}
